export default __webpack_public_path__ + "static/media/WAZE_NEW.2b850b80.png";